import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Contribution() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Contribution
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Contribution
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Contribution-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Collaborations
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-1-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        DTU Biobrick Workshop
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-1-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Bielefeld European Meetup
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-1-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        The Swedish iGEM Conference
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-1-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Madrid European Meetup
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-1-5")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        The Nordic iGEM Conference
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-1-6")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        The Swedish iGEM Teams Educational Game
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-1-7")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        The iGEM McMaster Sticker Book
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Contributions
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-2-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        GuaA-GuaB composite BioBrick
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-2-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        iGEM Stockholm For Dummies handbook
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-2-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Swedish iGEM Teams Educational Game
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Contribution-2-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        iGEM Stockholm Online Game
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Contribution-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Collaborations
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                Being an iGEM team means being international, and this year the Stockholm team was
                                able to participate in conferences across 5 different countries, interacting and
                                sharing ideas with teams and individuals across the globe, whilst also establishing
                                new collaborative projects.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-1-1" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            DTU Biobrick Workshop
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                The first meetup of the year took place at Denmark’s Technical University (DTU),
                                even before our team had finalised a project idea. During the workshop, we
                                participated in many wet and dry lab exercises helping us learn new skills. We also
                                got to hear some tips and advice from previous iGEM members which was very insightful
                                especially as we were only beginning our iGEM journey.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-1.png"
                                className="w-full max-w-sm mt-5 mx-auto rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-2.png"
                                className="w-full max-w-sm mt-5 mx-auto rounded-2xl"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-1-2" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            Bielefeld European Meetup
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                Fresh after finalising this year’s project idea, our team got to present our project
                                poster at the European meetup in Bielefeld. It was wonderful to get a glimpse of
                                other teams projects, but also very helpful giving and receiving constructive feedback.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-3.png"
                                className="w-full max-w-lg mt-5 mx-auto rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-4.png"
                                className="w-full max-w-lg mt-5 mx-auto rounded-2xl"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-1-3" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            The Swedish iGEM Conference - Lund
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                During the start of summer, we met up with all the Swedish teams at the Swedish
                                iGEM conference hosted by the Lund team. During which we shared the ideas behind
                                our project and our project timelines. We were also given the opportunity to share
                                and discuss the different aspects of our iGEM teams, such as team recruitment,
                                division of wet/dry lab work and so on.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-5.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-6.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-1-4" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            Madrid European Meetup
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                Our second European meetup was held in Madrid, where we got to hear multiple
                                interdisciplinary lectures from professors at Universidad Complutense de Madrid,
                                providing us with knowledge across all aspects of our iGEM project including areas
                                such as entrepreneurship.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-7.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-8.png"
                                className="w-full max-w-lg mt-5 mx-auto rounded-2xl"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-1-5" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            The Nordic iGEM Conference - Turku
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                The Nordic iGEM conference was by far the biggest conference we’ve attended. Having
                                had some practice with presenting our projects at past conferences, we were able to
                                participate in some friendly competition this time and placed third for our project
                                presentation. To finish off the conference we also attended a lovely dinner where we
                                got to reconnect with old teams and form partnerships with new teams.
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-9.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                            <img
                                src="https://static.igem.wiki/teams/5122/contribution/contribution-10.png"
                                className="w-full mt-5 rounded-2xl"
                                alt=""
                            />
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-1-6" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            The Swedish iGEM Teams Educational Game
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                This project is the result of a unique and collaborative effort between all the
                                Swedish iGEM teams: Lund, Uppsala, Linköping, Gothenburg, and Stockholm. By
                                combining the expertise, creativity, and diverse perspectives of each team’s
                                representatives, we were able to pool our strengths and resources to develop an
                                educational tool that highlights the exciting potential of synthetic biology.
                                Each team contributed ideas from their own projects, allowing us to create a richer
                                and more comprehensive experience. This collaboration was essential, as no single
                                team could have captured the breadth of knowledge and innovation represented across
                                the country. Together, we not only showcased the creativity of Swedish iGEM teams,
                                but also demonstrated the power of teamwork in advancing science communication and
                                education.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-1-7" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            The iGEM McMaster Sticker Book
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                This project was organized by iGEM McMaster Canada, which involved different iGEM
                                teams compiling sticker designs and writing a brief description of their project and
                                meaning behind each sticker. As iGEM Stockholm’s project this year was BioGlimmer, we
                                designed three stickers – our project logo, project mascot and project slogan.
                            </div>
                        </div>
                        <img
                            src="https://static.igem.wiki/teams/5122/add/add-1.png"
                            className="w-full mt-5 rounded-2xl"
                            alt=""
                        />
                    </div>
                    <div>
                        <div id="Contribution-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Contributions
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                This year, several projects undertaken by our team we believe can be helpful for
                                future iGEM teams, as well as the broader synthetic biology community. Here we
                                highlight four such projects: our new composite part, our iGEM Stockholm For
                                Dummies handbook, and our two games: the card game and the online game.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-2-1" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            GuaA-GuaB composite BioBrick (BBa_K5122003)
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                As part of our research project we created a brand new composite part, coding for
                                the native E. coli guaA and guaB genes, as well as the aeBlue dye. Its intended
                                design is to induce overexpression of these two guanine synthesis genes in E. coli,
                                leading to an increased synthesis of the guanine nucleotide. Guanine being one of the
                                four DNA nucleotides makes its synthesis central to the viability of E. coli, and
                                therefore this BioBrick will be of use to other iGEM projects interested in modifying
                                this central pathway. In particular, enhancing the expression of these two genes is
                                expected to increase the viability of the cells in response to nutrient starvation
                                (1).  This has implications for iGEM:ers interested in not only cosmetics, but also
                                antibiotic resistance, bioreactors and metabolic engineering, among other things. On
                                a broader scale, we hope this effort will inspire future teams to pursue biosynthesis
                                of cosmetic ingredients, in iGEM:s new village. As described on this wiki, the
                                billion-dollar cosmetics market involves 1000s of compounds, many of which could
                                benefit from being acquired in more ethical ways. We posit that synthetic biology
                                is a promising solution to address these problems, using the principles laid out by
                                this project. To find out more about the specifics of the BioBrick, we kindly direct
                                you to our dry lab webpage, as well as the BioBrick repository.
                            </div>
                            <div className="mt-5">
                                1. Ipe, D.S., Sullivan, M.J., Goh, K.G.K, Hashimi, S.M., Munn, A.L., Ulett, G.C.
                                Conserved bacterial de novo guanine biosynthesis pathway enables microbial survival
                                and colonization in the environmental niche of the urinary tract. ISME J. 2021
                                Mar;15:2158–2162.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-2-2" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            iGEM Stockholm For Dummies handbook
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                The handbook is meant to collect and succinctly present the accumulated knowledge
                                of iGEM Stockholm’s 9 teams, and is specifically tailored to future iGEM Stockholm
                                teams. It covers the entire duration of an iGEM project, from recruiting the team
                                all the way to presenting at the Jamboree, and gives suggestions for what to do
                                and not to do at each step. It also presents a suggested project timeline
                                week-by-week, collecting what should be done when and in what sequence. Although
                                most of it is written based on the specific circumstances of doing an iGEM project
                                in Stockholm, some of its chapters, such as those on team recruitment, brainstorming
                                and team structure can be useful to any future iGEM team.
                            </div>
                        </div>
                        <div className="w-full h-screen mt-5">
                            <object
                                type="application/pdf"
                                width="100%"
                                height="100%"
                                data="https://static.igem.wiki/teams/5122/pdf/abridged-version-igem-stockholm-handbook-2024-ed-1.pdf"
                            >
                                <p>Your web browser doesn't have a PDF plugin.</p>
                            </object>
                        </div>

                    </div>
                    <div>
                        <div id="Contribution-2-3" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            Swedish iGEM Teams Educational Game
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                The card game, as explained on the Education page, takes you through an iGEM
                                project from fundraising to transformation. Although not contributing to future
                                projects directly, we believe it to be a decent time, and that’s plenty enough.
                                When waiting for your next western blot transfer with your lab mates, this game
                                will not only be lots of fun, but will engage you with the core concepts of iGEM:
                                plasmid design, purchasing lab equipment, and unforeseen circumstances. Enjoy!
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Contribution-2-4" className="text-xl font-bold text-gray-800 sm:text-2xl mt-10">
                            iGEM Stockholm Online Game
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                Finally, our very own online game, as explained on the Education page, follows
                                the iGEM Stockholm teams throughout its 9 projects. Here again, we offer a chance
                                for iGEMers to explore what we and our predecessors have been cooking up in and
                                outside of the lab. It’s a chance to get inspiration for your own future project,
                                but also to get an understanding of how iGEM itself works and has evolved over
                                the years.
                            </div>
                        </div>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}